import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Log } from 'app/core/logging/log';
import { MovementModel } from 'app/models/movement-model';
import { PageModel } from 'app/models/page-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';

export interface MyWalletDialogData {
  title: string;
  message: string;
}

@Component({
    selector: 'app-my-wallet-dialog',
    templateUrl: './my-wallet-movements-dialog.component.html',
    styleUrls: ['./my-wallet-movements-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyWalletMovementsDialogComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = ['description', 'amount', 'createdAt'];
  pageMovements: PageModel<MovementModel> = {
    content: [],
    pageNumber: 0,
    pageSize: 0,
    totalPages: 0,
    totalElements: 0,
    first: false,
    last: false
  };
  movements = new MatTableDataSource<MovementModel>([]);

  constructor(
    public dialogRef: MatDialogRef<MyWalletMovementsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MyWalletDialogData,
    private appService: AppService, 
    private restService: RestService, 
  ) {}

    ngOnInit() {
      this.getWalletMovements();
  
      this.movements.filterPredicate = (dato: MovementModel, filtro: string) => {
        const textoTransformado = `
          ${new Intl.DateTimeFormat('es-ES').format(dato.createdAt)}
          ${dato.type}
          ${dato.amount}
          ${this.showDescriptionMovement(dato.description)}
        `.toLowerCase();
  
        return textoTransformado.includes(filtro.trim().toLowerCase());
      };
  
    }

    ngAfterViewInit() {
    this.movements.paginator = this.paginator;
    this.movements.sort = this.sort;
  }

    applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.movements.filter = filterValue.trim().toLowerCase();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getWalletMovements(){
    this.restService.getWalletMovements().subscribe(result => {
      Log.debug('getWalletMovements', result);
      this.pageMovements = result;
      this.movements.data = this.pageMovements.content;
    });
  }

  showDescriptionMovement(key_: string){
    let key = 'myWallet.movement.' + key_;
    let description = this.appService.getTraduccion(key);
    if(description == key){
      return key_;
    }else{
      return description;
    }
  }
  
}
